import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-checkbox-group',
  templateUrl: './formly-checkbox-group.component.html',
  styleUrls: ['./formly-checkbox-group.component.scss'],
})
export class FormlyCheckboxGroupComponent extends FieldType {
  defaultCheckboxValues: { [key: string]: boolean } = {}

  ngOnInit() {
    if (this.props.options && Array.isArray(this.props.options)) {
      this.props.options.forEach((option, index) => {
        const defaultvalue =
          this.model[option.value] || this.props.defaultValue || false

        this.defaultCheckboxValues[option.value] = defaultvalue
      })

      const defaultPlusValue = {
        ...this.defaultCheckboxValues,
        ...this.formControl.value,
      }

      this.formControl.patchValue(defaultPlusValue)
    }
  }

  onChange(key: string, isChecked: boolean) {
    const updatedValues = { ...this.formControl.value, [key]: isChecked }
    this.formControl.patchValue(updatedValues)
  }
}
